import * as React from "react"
import trans from "trans"

import {
    Section,
    css,
} from "@bdfx/mergado-ui-kit"

import {
    projectId,
} from "app/helpers/api";

export const AdminMenuItems = ['projects_overview', 'project_info', 'project_health', 'system', 'products', 'templates', 'random_images', 'rules', 'queries', 'mergado_products', 'mergado_elements', 'mergado_formats', 'rabbit', 'find_by', 'audit_promo_templates', 'mcp']
export type AdminMenuType = 'projects_overview' | 'project_info' | 'project_health' | 'system' | 'products' | 'templates' | 'random_images' | 'rules' | 'queries' | 'mergado_products' | 'mergado_formats' | 'mergado_elements' | 'rabbit' | 'find_by' | 'audit_promo_templates' | 'mcp'

import RabbitQueues from "../components/rabbit-queues";
import MergadoRules from "../components/mergado-rules";
import MergadoQueries from "../components/mergado-queries";
import SystemInfo from "../components/system-info";
import SuperadminMenu from "../components/superadmin-menu";
import ProjectInfo from "../components/project-info";
import SelectProject from "./select-project";
import ProductsImages from "../components/product-images";
import RandomImages from "../components/random-images";
import Templates from "../components/templates";
import ProjectsOverview from "../components/projects-overview";
import MergadoProducts from "../components/mergado-products";
import {inIframe} from "app/helpers/mergado";
import ProjectHealth from "../components/project-health";
import {RouterType, withRouter} from "app/components/routes";
import FindBy from "../components/find-by";
import FormatSpecifications from "../components/format-specifications";
import MergadoElements from "superadmin/components/mergado-elements";
import AuditPromoTemplates from "superadmin/components/audit-promo-templates";
import MCP from "superadmin/components/mcp";

interface Props {
    router: RouterType
}

interface State {
    selectedProjectId: number
    selectedTemplateId: number
    selectedProductId: number
}

class Superadmin extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props)

        this.state = {
            selectedProjectId: projectId,
            selectedTemplateId: null,
            selectedProductId: null,
        }
    }

    setTemplateId = (templateId: number) => {
        this.setState({selectedTemplateId: templateId})
    }

    setProjectId = (projectId: number) => {
        this.setState({selectedProjectId: projectId})
    }

    setProductId = (productId: number) => {
        this.setState({selectedProductId: productId})
    }

    getModuleByMenu = (activeMenuItem: AdminMenuType) => {
        const {selectedProjectId, selectedTemplateId, selectedProductId} = this.state

        switch(activeMenuItem) {
            case 'projects_overview':
                return <ProjectsOverview
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                />
            case 'project_health':
                return <ProjectHealth
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                />
            case 'system':
                return <SystemInfo
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                />
            case 'project_info':
                return <ProjectInfo
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                    selectedProductId={selectedProductId}
                />
            case 'products':
                return <ProductsImages
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                    selectedProductId={selectedProductId}
                />
            case 'random_images':
                return <RandomImages
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                    selectedProductId={selectedProductId}
                />
            case 'templates':
                return <Templates selectedProjectId={selectedProjectId} />
            case 'rules':
                return <MergadoRules selectedProjectId={selectedProjectId}/>
            case 'queries':
                return <MergadoQueries selectedProjectId={selectedProjectId}/>
            case 'mergado_products':
                return <MergadoProducts
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                    selectedProductId={selectedProductId}
                />
            case 'mergado_elements':
                return <MergadoElements selectedProjectId={selectedProjectId} />
            case 'mergado_formats':
                return <FormatSpecifications selectedProjectId={selectedProjectId} />
            case 'rabbit':
                return <RabbitQueues/>
            case 'find_by':
                return <FindBy selectedProjectId={selectedProjectId} selectedTemplateId={selectedTemplateId} />
            case 'audit_promo_templates':
                return <AuditPromoTemplates />
            case 'mcp':
                return <MCP selectedProjectId={selectedProjectId} selectedTemplateId={selectedTemplateId} />
            default:
                return <div/>
        }
    }

    render() {
        const {selectedProjectId, selectedTemplateId, selectedProductId} = this.state
        const activeMenuItem : AdminMenuType = this.props.router.params.activemenu ?? 'find_by'

        return (
            <StyledSection
                className='main'
                header={<SuperadminMenu activeMenuItem={activeMenuItem} />}
                dataActiveMenuItem={activeMenuItem}
            >
                {!['system', 'rabbit', 'random_images', 'find_by', 'audit_promo_templates'].includes(activeMenuItem) &&
                <SelectProject
                    setTemplateId={this.setTemplateId}
                    setProjectId={this.setProjectId}
                    setProductId={this.setProductId}
                    selectedProjectId={selectedProjectId}
                    selectedTemplateId={selectedTemplateId}
                    selectedProductId={selectedProductId}
                />
                }

                <StyledDiv key={`selected_project_${selectedProjectId}`}>
                {this.getModuleByMenu(activeMenuItem)}
                </StyledDiv>
            </StyledSection>
        )
    }
}

const StyledDiv = css('div')({
    width: '100%',
    '@media screen and (max-width: 1024px)': {
        paddingBottom: inIframe() ? '100px' : '10px',
        overflow: 'auto',
    },
})

const StyledSection = css(Section)({
    '@media screen and (max-width: 800px)': {
        ' > .m-header > .m-header-content': {
            display: 'none',
            visibility: 'hidden',
        },
        ' > .m-header > .m-suffix': {
            padding: '0 !important',
            fontSize: 'small',
            ' img.m-image': {
                display: 'none',
                visibility: 'hidden',
            },
            ' nav': {
                padding: 0,
            }
        },
        ' .react-select-item-label': {
            whiteSpace: 'normal',
        }
    },
}, props => {
    return {
        ' .m-content': {
            overflow: 'auto',
            padding: props.dataActiveMenuItem === 'audit_promo_templates' ? '0px' : '10px',
        },
    }
})

export default withRouter(Superadmin)